import { EVENT } from "@/constants/event";
import { Button } from "antd";
import { useCallback } from "react";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";
export default function SearchFocusButton({
  searchScope,
  text = "搜索",
  className,
}: {
  searchScope: string;
  text?: string;
  className?: string;
}) {
  const focusSearch = useCallback(() => {
    const event = new CustomEvent(EVENT.SEARCH_BAR_FOCUS, {
      detail: searchScope,
    });
    window.dispatchEvent(event);
  }, [searchScope]);

  return (
    <Button
      className={`${className} ${styles.btn}`}
      type="default"
      onClick={focusSearch}
      data-gd-click="button_click"
      data-button-name={text}
    >
      <HBIcon type={"ic_search"} className={styles.icon} />
      {text}
    </Button>
  );
}
